export default "__VITE_ASSET__CfotgaGp__"